import { render } from "./unallocatedSessionDelete.vue?vue&type=template&id=9b516046&scoped=true"
import script from "./unallocatedSessionDelete.vue?vue&type=script&lang=js"
export * from "./unallocatedSessionDelete.vue?vue&type=script&lang=js"

import "./unallocatedSessionDelete.vue?vue&type=style&index=0&id=9b516046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b516046"]])

export default __exports__